import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { updatePhoto } from '../../store/customer/actions';

import { colors } from "../../styles/variables.js"
import Svg from "../../assets/icons/icons";

import {
  ErrorSt,
  ProjectImageSt,
  ProjectWrapEmailSt,
  ImgTopSt,
  WrapImgMobSt,
  WrapImgSt,
  ProfileFotoInputSt
} from './style.js';

const AccountChangeFoto = ({ imgPoster, type }) => {
  const [errors, setErrors] = useState(false);

  const photoInput = useRef(null);

  const dispatch = useDispatch();
  const token = useSelector((store) => store.auth.dataToken.token);

  const focusTextInput = () => {
    const FILE_TYPES = ['jpg', 'jpeg', 'png'];
    const file = photoInput.current.files[0];
    const fileName = file && file.name.toLowerCase();
    const matches = file && FILE_TYPES.some(function (it) {
      return fileName.endsWith(it);
    });
    if (matches) {
      const reader = new FileReader();
      reader.onload = () => {
        let preview = document.querySelector('.profile-change');
        preview.src = reader.result;
      };
      reader.readAsDataURL(file);
      setErrors("");
      dispatch(updatePhoto(file, token));
    } else {
      setErrors("некорректный формат файла");
    }
  };

  return (
    <>
      <WrapImgSt className={type === "mobile" ? "profile profile-mob" : "profile"}>
        {type === "mobile"
          ? <WrapImgMobSt className="profile">
            <ImgTopSt src={imgPoster} width="300" className="profile-change" />
          </WrapImgMobSt>
          : <ProjectImageSt src={imgPoster} width="300" className="profile profile-change" />
        }
        <ProjectWrapEmailSt>
          <Svg width="24" height="24" type="add_a_photo" color={colors.white} />
          <ProfileFotoInputSt type="file" ref={photoInput} onChange={() => focusTextInput()} accept="image/jpeg,image/png,image/gif" />
        </ProjectWrapEmailSt>
        <ErrorSt>{errors}</ErrorSt>
      </WrapImgSt>
    </>
  );
};

export default AccountChangeFoto;
